<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="stylus">
html
  background-color: #fff;
  height: 100%;
  body
    height: 100%;
  p,div,h1,h2,span
    margin: 0
    padding: 0
    .dyb-tabs
      .van-tab
        padding 0 20px !important
  #app
    height: 100%;
    background-color: #fff;
</style>

<script>
export default {
  name: 'app'
}
</script>
